<template>
  <div id="qrCode" />
</template>

<script>
import QRCodeStyling from "qr-code-styling";
export default {
  mounted: function () {
    this.generateQRCode();
  },
  methods: {
    generateQRCode() {
      const requestType = "authorization";
      const qrCode = new QRCodeStyling({
        width: 200,
        height: 200,
        margin: 10,
        type: "svg",
        data:
          "https://" +
          process.env.VUE_APP_URLPATH +
          "x-id.me/xid?request_type=" +
          requestType +
          "&login_challenge=" +
          this.$route.query.login_challenge +
          "&browser=pc",
        image: "/logo.svg",
        dotsOptions: {
          color: "#222222",
          type: "rounded",
        },
        cornersSquareOptions: {
          type: "extra-rounded",
          color: "#33CEAA",
        },
        cornersDotOptions: {
          color: "#33CEAA",
        },
        backgroundOptions: {
          color: "#f2f2f2",
        },
        imageOptions: {
          crossOrigin: "anonymous",
          margin: 0,
        },
      });

      qrCode.append(document.getElementById("qrCode"));
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
#qrCode
  +size(200px, 200px, 10px)
  overflow: hidden
</style>